// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2JG7t","modalFooterButton":"ModalNotes_modalFooterButton__3jsNR"};